import React from "react";
import _ from "lodash";
import { Router } from "react-router";
import { Provider } from "react-redux";
import PropTypes from "prop-types";
import { persistStore } from "redux-persist";
import config from "config";
import Loading from "./components/Loading";
import modules from "modules";

const alertActions = modules.actions.alerts;
const configActions = modules.actions.configuration;

class App extends React.Component {
  static propTypes = {
    store: PropTypes.object.isRequired,
    routes: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
  };

  state = {
    rehydrated: false,
    loaded: false,
  };

  componentWillMount() {
    const { store } = this.props;
    const { persistConfig } = config;

    this.props.store.dispatch(configActions.getConfiguration({}));

    if (localStorage.reducerVersion !== persistConfig.reducerVersion) {
      console.log("PERSIST PURGE : Reducer Version Change Detected");
      persistStore(store, persistConfig.storeConfig).purge();
      localStorage.setItem("reducerVersion", persistConfig.reducerVersion);
      this.setState({ rehydrated: true, loaded: true });
    } else {
      // Run rehydration of persisted stores with config options required for immutable transforms
      persistStore(this.props.store, config.persistConfig, (error) => {
        if (error) console.error("Rehydrated Error", error);
        // TODO check for rehydration error before continuing with loading the app
        this.setState({ rehydrated: true });
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("COMPONENT DIS UPDATE App");
    if (this.state.rehydrated && !prevState.rehydrated) {
      const auth = this.props.store.getState().auth;
      if (auth.token) {
        this.unsubscribe = this.props.store.subscribe(this._onStoreChange);
        this.props.store.dispatch(alertActions.getFormData());
        this.props.store.dispatch(configActions.getClusters());
        this.props.store.dispatch(configActions.getLogicalLocations());
        this.props.store.dispatch(configActions.getGeoLocations());
        this.props.store.dispatch(configActions.getCriticalMoments());
      } else {
        this.setState({ loaded: true });
      }
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.rehydrated !== nextState.rehydrated ||
      this.state.loaded !== nextState.loaded
    );
  }

  _onStoreChange = () => {
    let { alerts, configuration } = this.props.store.getState();
    // if (!_.isEmpty(alerts.formData)) {
    this.setState({ loaded: true });
    this.unsubscribe();
    // }
  };

  render() {
    if (!this.state.rehydrated || !this.state.loaded) {
      return <Loading />;
    }

    return (
      <Provider store={this.props.store}>
        <Router history={this.props.history} children={this.props.routes} />
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/app.jsx